import { useMutation, useQueryClient } from '@tanstack/react-query'

import { commentApi } from '../api/commentApi'
import { getCommentsOptions } from './useCommentsQuery'

export const useDeleteCommentMutation = (commentId: number, publicationId: number) => {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: () => commentApi.deleteComment(commentId),
    onSuccess: () => {
      queryClient.resetQueries({
        queryKey: getCommentsOptions(publicationId).queryKey,
      })
    },
  })
}
